import React, {Component} from 'react'
import styled from 'styled-components';
import { media } from '../../styles/utils'

class InputText extends Component {
    
    render() {

        return (
            <Wrapper>
                <Label>{this.props.label}</Label>
                <Input 
                    type="text"
                    name={this.props.name}
                    // placeholder={this.props.placeholder}
                    value={this.props.value}
                    onChange={this.props.onChangeValue}
                    required={ this.props.required ? 'required' : null }
                />
            </Wrapper>
        )
    }
}

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`

export const Label = styled.div`
    display: flex;
    width: 100%;
    font-family: 'Platform-Regular';
    font-size: 11px;
    color: #807c7c;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 4px;
`

export const Input = styled.input`
    display: flex;
    height: 30px;
    width: 100%;
    appearance: none;
    border: none;
    border-bottom: 1px solid #DADADA;
    flex: 1;
    background: none;
    margin-bottom: 38px;
    border-radius: 0;

    font-family: Platform-Light;
    font-size: 16px;
    color: black;
    letter-spacing: 0.47px;

    &:focus{
        outline: none;
    }

    &, &::placeholder {
        color: black;
    }

    box-sizing: border-box;
`

export default InputText;



// WEBPACK FOOTER //
// ./client/components/InputText/InputText.js